
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","stroke":"#303D4E","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.36 8.179a6.897 6.897 0 010 9.754l-3.807 3.807a6.897 6.897 0 01-9.754-9.754M31.606 8.178A6.89 6.89 0 0137.8 6.285M22.864 26.614a8.377 8.377 0 002.364-4.695l.52-3.51","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.861 26.61a8.379 8.379 0 014.695-2.363l3.51-.52M19.94 29.532L18.47 31M16.34 21.74a6.897 6.897 0 000-9.754l-3.807-3.808a6.897 6.897 0 00-9.754 9.754l3.807 3.808a6.897 6.897 0 009.754 0z","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.274 26.614a8.378 8.378 0 01-2.363-4.695l-.52-3.51","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.278 26.61a8.38 8.38 0 00-4.696-2.363l-3.51-.52M21.244 26.576L25.668 31M25.995 5.07a4.07 4.07 0 11-8.138-.001 4.07 4.07 0 018.138 0z","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.436 1.89l-.292.486a4.96 4.96 0 00.124 5.308l.172.257M19.488 1.89l.293.486a4.96 4.96 0 01-.124 5.308l-.172.257M34.254 19.67l-.719.718M40.955 12.968l-5.385 5.386M39.22 9.557l-5.326 5.326M33.655 12.37l5.266 5.266M36.647 10.215l4.428 4.428M34.852 8.42l.479.479","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    